import React from 'react';
import {graphql} from 'gatsby';

import Home from '~containers/home';
import Layout from '~components/layout';
import Seo from '~components/seo';
import {firebaseAnalytics} from '~utils/firebase';
import buildOrganizationSchema from '~utils/organization-schema';

const IndexPage = ({location, data}) => {
  React.useEffect(() => {
    firebaseAnalytics.logEvent('Homepage_visited');
  }, []);

  const banners = data.allBanner.nodes;
  const organizationSchema = buildOrganizationSchema(data.site.siteMetadata.siteUrl);

  return (
    <Layout>
      <Seo title='Home' schema={organizationSchema} />
      <Home location={location} banners={banners} />
    </Layout>
  );
};

export const query = graphql`
  {
    site {
      siteMetadata {
        siteUrl
      }
    }
    allBanner {
      nodes {
        id
        caption
        imageUrl
        name
        type
        url
      }
    }
  }
`;

export default IndexPage;
